import { render, staticRenderFns } from "./Activate2fa.vue?vue&type=template&id=d64f4e2e&"
import script from "./Activate2fa.vue?vue&type=script&lang=js&"
export * from "./Activate2fa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports